const Vue3CdnUrl =
  "https://cdn.eberl-online.cloud/vue/vue-3.5.18/dist/vue.global.prod.js";
const VueDiffTextCdnUrl =
  "https://cdn.eberl-online.cloud/vue-diff-text/vue-diff-text-1.5.4/dist/vue-diff-text.umd.js";
const Vue3ScriptId = "eo-vue3-diff-runtime";
const VueDiffTextScriptId = "eo-vue-diff-text-umd";

const loadScriptOnce = ({ src, id }) =>
  new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[data-script-id="${id}"]`
    );
    if (existingScript) {
      if (existingScript.dataset.loaded === "true") {
        resolve();
        return;
      }
      existingScript.addEventListener("load", () => resolve(), { once: true });
      existingScript.addEventListener(
        "error",
        () => reject(new Error(`Script konnte nicht geladen werden: ${src}`)),
        { once: true }
      );
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.dataset.scriptId = id;

    script.onload = () => {
      script.dataset.loaded = "true";
      resolve();
    };
    script.onerror = () =>
      reject(new Error(`Script konnte nicht geladen werden: ${src}`));

    document.head.appendChild(script);
  });

export const ensureVue3DiffWordsDependencies = async () => {
  if (
    window.__eoVue3DiffWordsBridge?.Vue3 &&
    window.__eoVue3DiffWordsBridge?.DiffHtml
  ) {
    return window.__eoVue3DiffWordsBridge;
  }

  if (!window.__eoVue3DiffWordsBridgePromise) {
    window.__eoVue3DiffWordsBridgePromise = (async () => {
      const previousVueGlobal = window.Vue;

      await loadScriptOnce({ src: Vue3CdnUrl, id: Vue3ScriptId });
      window.__eoVue3Runtime = window.__eoVue3Runtime || window.Vue;
      const Vue3 = window.__eoVue3Runtime;

      if (!Vue3?.createApp || !Vue3?.reactive || !Vue3?.h) {
        throw new Error("Vue 3 Runtime wurde nicht korrekt geladen.");
      }

      window.Vue = Vue3;
      try {
        await loadScriptOnce({
          src: VueDiffTextCdnUrl,
          id: VueDiffTextScriptId
        });
      } finally {
        window.Vue = previousVueGlobal;
      }

      const DiffHtml = window.VueDiffText?.DiffHtml;
      if (!DiffHtml) {
        throw new Error(
          "DiffHtml konnte aus vue-diff-text nicht geladen werden."
        );
      }

      window.__eoVue3DiffWordsBridge = { Vue3, DiffHtml };
      return window.__eoVue3DiffWordsBridge;
    })().catch(error => {
      window.__eoVue3DiffWordsBridgePromise = null;
      throw error;
    });
  }

  return window.__eoVue3DiffWordsBridgePromise;
};

const NBSP_PATTERN = new RegExp(String.fromCharCode(0x00a0), "g");
const ZERO_WIDTH_PATTERN = new RegExp(
  "[" +
    String.fromCharCode(0x200b) +
    "-" +
    String.fromCharCode(0x200d) +
    String.fromCharCode(0xfeff) +
    "]",
  "g"
);

export const normalizeHtmlForDiff = input => {
  if (!input) return "";

  const source = String(input).replace(/\r\n/g, "\n");
  const parts = source.split(/(<[^>]+>)/g);

  return parts
    .map(part => {
      if (!part || (part.startsWith("<") && part.endsWith(">"))) {
        return part;
      }

      const normalizedText = part
        .replace(NBSP_PATTERN, " ")
        .replace(ZERO_WIDTH_PATTERN, "")
        .replace(/\s+/g, " ");

      return normalizedText.normalize
        ? normalizedText.normalize("NFC")
        : normalizedText;
    })
    .join("");
};
